import { ContainerFooter } from "./styled";

interface FooterProps {
  isAbsolute: boolean;
}

const Footer: React.FC<FooterProps> = ({ isAbsolute }) => {
  return (
    <ContainerFooter isAbsolute={isAbsolute}>
      <p>© Portal Assinando - Empresa do Grupo Docteka</p>
    </ContainerFooter>
  );
};

export default Footer;
